import React, { Component } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import i18n from '~/i18n'
import { connect } from 'react-redux'
import TemplateImageLoader from '~/pages/cp/automation/addNew/templateImageLoader.jsx'
import helpers from '~/Classes/helpers'
@connect((store) => {
    return { accountMaster: store.accountMaster }
})
class FormUpdate extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: {}
        }
        this.updateField = this.updateField.bind(this)
        this.checkForm = this.checkForm.bind(this)
        this.edit = this.edit.bind(this)
        this.next = this.next.bind(this)
    }

    componentDidMount() {
        this.checkForm()
    }

    updateField(ev, options) {
        var form = this.props.form
        if (options) {
            form.options[ev.currentTarget.name] = ev.currentTarget.value
        } else {
            form[ev.currentTarget.name] = ev.currentTarget.value
        }
        this.checkForm()
        this.props.update()
    }

    checkForm() {
        var errors = {}
        var options = this.props.form.options

        if (options.onUpdate === 'redirect') {
            if (!options.updateRedirectUrl) {
                errors.updateRedirectUrl = i18n.t('form:step3.errUrl')
            } else if (
                options.updateRedirectUrl.toLowerCase().indexOf('http://') < 0 &&
                options.updateRedirectUrl.toLowerCase().indexOf('https://') < 0
            ) {
                errors.updateRedirectUrl = i18n.t('form:step3.errUrlHttp')
            }
        }
        if (options.onUpdate === 'redirect' && !options.updateRedirectUrl)
            errors.updateRedirectUrl = i18n.t('form:step3.errUrl')
        if (options.onUpdate === 'message' && !options.updateMessage)
            errors.updateMessage = i18n.t('form:step3.errMessage')

        this.setState({
            errors
        })
    }

    async edit() {
        const isUsingNewEditor = awaithelpers.getTemplateEditorVersion(this.props.accountMaster, true)
        this.props.save().then(() => {
            var redirect = '/cp/groups/' + this.props.groupId + '/forms/create/' + this.props.form.id + '/4'
            const editorUrl = isUsingNewEditor.canUseV2
                ? '/cp/templates/add/dragDropv2/'
                : '/cp/templates/add/dragDrop/'

            this.props.history.push(
                editorUrl +
                    '?form=true&groupId=' +
                    this.props.groupId +
                    '&formId=' +
                    this.props.form.id +
                    '&redirect=' +
                    redirect +
                    '&page=update'
            )
        })
    }

    next() {
        this.props.form.wizard.step3 = true
        this.props.update()
        if (this.props.form.options.onUpdate === 'replace') {
            this.edit()
        } else {
            this.props.changeStep(4, true)
        }
    }

    render() {
        return (
            <div>
                <Row>
                    <Column xs={12} md={4} className='mar-b25'>
                        <div
                            className='campaign-thumbnail'
                            style={{ width: '100%', height: '100%', minHeight: '150px' }}
                        >
                            <TemplateImageLoader
                                imageUrl={this.props.screenshotUrl}
                                form={this.props.form.formType === 1}
                            />
                        </div>
                    </Column>
                    <Column xs={12} md={8}>
                        <Paper>
                            <h4 className='mar-b25'>{i18n.t('form:step3.header')}</h4>

                            <Select
                                outerClassName='mar-b25'
                                name='onUpdate'
                                value={this.props.form.options.onUpdate}
                                data={[
                                    {
                                        label: i18n.t('form:step3.redirect'),
                                        value: 'redirect',
                                        disabled:
                                            this.props.form.options?.serve === 'click' ||
                                            this.props.form.options?.serve === 'clickButton'
                                    },
                                    { label: i18n.t('form:step3.message'), value: 'message' },
                                    {
                                        label: i18n.t('form:step3.update'),
                                        value: 'update',
                                        disabled:
                                            this.props.form.options?.serve === 'click' ||
                                            this.props.form.options?.serve === 'clickButton'
                                    }
                                ]}
                                onChange={(ev) => this.updateField(ev, true)}
                            />

                            {this.props.form.options.onUpdate !== 'replace' &&
                                this.props.form.options.onUpdate !== 'update' && (
                                    <div>
                                        {this.props.form.options.onUpdate == 'redirect' && (
                                            <TextInput
                                                outerClassName='mar-b25'
                                                value={this.props.form.options.updateRedirectUrl}
                                                error={this.state.errors.updateRedirectUrl}
                                                placeholder={i18n.t('form:step3.url')}
                                                name='updateRedirectUrl'
                                                onChange={(ev) => this.updateField(ev, true)}
                                                id='redirect'
                                                mergeTags={true}
                                            />
                                        )}
                                        {this.props.form.options.onUpdate == 'message' && (
                                            <TextInput
                                                outerClassName='mar-b25'
                                                value={this.props.form.options.updateMessage}
                                                error={this.state.errors.updateMessage}
                                                placeholder={i18n.t('form:step3.success')}
                                                name='updateMessage'
                                                onChange={(ev) => this.updateField(ev, true)}
                                            />
                                        )}
                                    </div>
                                )}
                        </Paper>
                    </Column>
                </Row>
                <div className='quickFlex end-xs'>
                    <Button
                        className='button-primary'
                        iconRight={<Icons icon='arrowRight' />}
                        disabled={!!Object.keys(this.state.errors).length}
                        text={
                            this.props.form.options.onUpdate === 'replace'
                                ? i18n.t('form:step3.design')
                                : i18n.t('form:step3.next')
                        }
                        onClick={this.next}
                    />
                </div>
            </div>
        )
    }
}

export default FormUpdate
